import React, { useState, useEffect } from "react"
import cardIcon from "../../assets/cardInfo.svg"
import InputField from "../../components/InputField/InputField"
import DashboardNavbar from "../../components/Navbar/DashboardNavbar"
import {
  convertToCash,
  getAllBanks,
  resolveAccountInfo
} from "../../utils/ApiRequests"
import jblSpeaker from "../../assets/jbl-speaker.png"
import { useParams } from "react-router-dom"
import MiniLoader from "../../components/Loaders/MiniLoader"
import { useToasts } from "react-toast-notifications"
import FullLoader from "../../components/Loaders/FullLoader"
import SuccessPopUp from "../../components/ModalContainer/Popups/SuccessPopUp"

const ConfirmAccount = () => {
  const [accountNumber, setAccountNumber] = useState("")
  const [banks, setBanks] = useState()
  const [bankCode, setBankCode] = useState("")
  const [accountName, setAccountName] = useState("")
  const [bankName, setBankName] = useState("")
  const [loading, setLoading] = useState(false)
  const [fullLoading, setFullLoading] = useState(false)
  const [success, setSuccess] = useState(false)

  const { orderId } = useParams()

  const { addToast } = useToasts()

  useEffect(() => {
    const abortController = new AbortController()
    const fetchBanks = async () => {
      try {
        const data = await getAllBanks()
        setBanks(data.data.data)
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.log(error.response)
        }
      }
    }

    fetchBanks()
    return () => {
      abortController.abort()
    }
  }, [])

  const checkInputs = () => {
    if (accountNumber === "" || accountName === "") {
      return false
    } else {
      return true
    }
  }

  const getAccountName = async () => {
    try {
      const { data } = await resolveAccountInfo(accountNumber, bankCode)
      console.log(data)
      setAccountName(data?.data.account_name)
    } catch (error) {
      console.log(error.response)
    }
    setFullLoading(false)
  }

  const submitRequest = async () => {
    setLoading(true)
    const requestBody = {
      bank_details: {
        account_name: accountName,
        account_number: accountNumber,
        bank_name: bankName,
        bank_code: bankCode
      }
    }
    try {
      const data = await convertToCash(orderId, requestBody)
      console.log(data)
      setLoading(false)

      addToast("Request submitted successfully.", { appearance: "success" })
      setSuccess(true)
    } catch (error) {
      addToast(error.response?.data.message || "An Error Occured", {
        appearance: "error"
      })
      setLoading(false)
    }
  }

  return (
    <>
      <DashboardNavbar />
      {fullLoading && <FullLoader />}
      {success && (
        <SuccessPopUp
          content="Items converted successfully"
          successTitle="Back to Gift Tracker"
          successLink="/gift-tracker"
        />
      )}

      <div className="global-container py-20 my-20">
        <div className="header my-10">
          <h1 className="text-3xl">Create Account</h1>
          <p>A bank account has been found in your history</p>
        </div>

        <div className="account__bank-item-info shadow p-10 mobiles:p-3 flex flex-wrap border-r-2 border-gray-200">
          <div className="w-1/2 mobiles:w-full border-r p-5">
            <div className="img-header flex pb-5">
              <img src={cardIcon} alt="card-icon" className="my-auto pr-5" />
              <p className="my-auto">
                Account must be in the name of your user account.
              </p>
            </div>
            <div className="form-wrapper">
              <InputField
                label="Input account number"
                id="lastname"
                htmlFor="lastname"
                placeholder="Input account number"
                value={accountNumber}
                type="number"
                required
                handleChange={e => {
                  setAccountNumber(e.target.value)
                }}
              />
              <div className="bank__select mb-5">
                <label htmlFor="SelectBank"> Select Bank </label>
                <select
                  name="bank"
                  id=""
                  onChange={e => {
                    setBankCode(e.target.value)
                    let index = e.nativeEvent.target.selectedIndex
                    setBankName(e.nativeEvent.target[index].text)
                  }}
                  onBlur={() => {
                    getAccountName()
                    setFullLoading(true)
                  }}
                  className="w-full border border-sbg-light-grey-2 px-2 py-2 mt-1.5 text-grey focus:outline-none placeholder-sbg-dark-blue placeholder-opacity-10"
                >
                  <option value="" className="text-grey">
                    Select Bank
                  </option>
                  {banks?.map(bank => {
                    return <option value={bank.code}>{bank.name}</option>
                  })}
                </select>
              </div>

              <InputField
                label="Account Name"
                readOnly
                id="lastname"
                htmlFor="lastname"
                className="py-2 mt-1.5"
                placeholder="Input account name"
                value={accountName}
                type="select"
                required
              />
              {loading ? (
                <MiniLoader />
              ) : (
                <button
                  type="submit"
                  className={`px-8 py-3 text-center rounded text-white bg-sbg-light-green font-medium text-xs focus:outline-none ${
                    !checkInputs() && "btn-disabled"
                  }`}
                  onClick={() => {
                    console.log("clicked")
                    submitRequest()
                  }}
                  disabled={!checkInputs()}
                >
                  SUBMIT
                </button>
              )}
            </div>
          </div>
          <div className="w-1/2 hidden">
            <div className="gift__tracker-card-wrapper mx-10 p-5 rounded-md">
              <h3>Convert 8 items to cash</h3>
              <h1>N65,000</h1>
              <div className="img__items-wrapper my-5">
                <div className="img-box">
                  <img src={jblSpeaker} alt="item-name" />
                </div>
                <div className="img-box">
                  <img src={jblSpeaker} alt="item-name" />
                </div>
                <div className="img-box">
                  <img src={jblSpeaker} alt="item-name" />
                </div>
                <div className="img-box">
                  <img src={jblSpeaker} alt="item-name" />
                </div>
                <div className="img-box">
                  <img src={jblSpeaker} alt="item-name" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ConfirmAccount
